import services from './services.js';
import viewPhoto from 'src/common/js/viewPhoto';
import validate from 'validate';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';

//组件
import tree from 'Tree';
import areaSelect from 'area-select';
/*  一、新增代理区域逻辑》》》
        签约项目为：
        1.联帮在线：》代理级别：0试课、1正式
        2.hi幼教：》代理级别：0试课、1正式、2会销
        3.智趣坞业务：》代理级别：0试课、1图书正式、2 Q4正式、3体验

        字段必填：
        1.合同号：只有代理级别为AgentLevel=1时候必填，后面新增的体验AgentLevel=3情况下也为必填 ，新增C级商 B级商 A级商：合同号必填；需上传经销合作协议
        2.签约区域和授权经销期限：只有新增的智趣坞体验级别不需要填写，其他的是必填
        3.公开课：联帮在线、hi幼教，智趣坞中的体验级别签约项目都有公开课字段，但是只有代理级别为正式AgentLevel=1和体验AgentLevel=3为必填
        4.代理类型（独家、非独家）：只有在智趣坞下的试课、Q4正式级别下的才出现，且必填
        5.独家订货量和合同预付款：只有在代理类型为独家时候显示，且必填
        6.设备预付款：只有在代理类型为非独家时候才显示，且必填
        7.体验零售订单和销售订货单号：只有在智趣坞下的体验级别出现，且必填
        8.选择政策：只有在hi幼教项目下才显示，但是只有正式的代理级别才是必填项
        9.权益金：只有联帮在线下的显示，且必填
        10.经销合同协议：C级商 B级商 A级需上传经销合作协议

        <!-- 必填逻辑：合同预付款填写了，订货量和订货单价选填，但是订货量或者订货单价其中一个填写，另外一个就是必填，而合同预付款为选填 -->

    二、修改代理区域逻辑
        不可修改逻辑
        1.签约项目、代理级别、代理类型不可以修改：当代理级别为正式AgentLevel=1或者Q4正式、或会销AgentLevel=2时
        2.独家订货量和合同预付款，设备预付款不可修改：当代理级别为Q4正式、或会销AgentLevel=2时
*/
export default {
    mixins: [services],
    components: {
        'tree': tree,
        'area-select': areaSelect
    },
    props: {
        isReadOnly: {
            default: false
        },
        myIndex: {
            default: 1
        },
        value: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hasDelFn: {
            default: true
        },
        isHideContractNumber: {
            default: true
        },
        isHideAgentLevel: {
            default: true
        },
        inReadonlyCanUpdate_AgentLevel: {
            default: false
        },
        inReadonlyCanUpdate_OpenClass: {
            default: false
        },
        inReadonlyCanUpdate_PolicyTypeName: {
            default: false
        },
        //新增代理商
        isAdd: {
            default: false
        },
        //新增代理商类型（转正时候显示）
        // isApply:{
        //     default:false
        // }
    },
    data() {
        return {
            getAddressInfoBtnLoading: false,
            cptInReadonlyCanUpdate_PolicyTypeName: false,
            agentLeveDisabled: false,
            DescriptionList: this.$store.state.DescriptionList,
            formInline: {},
            choiceProjectTypeSignMateriel: [], //this.$store.state.ProjectTypeSignMateriel：物料
            isSetData: false,
            valid: false,
            //代理信息
            agentInfo: this.refGetAgenInfo(),
            areaInfo: this.refGetAreaInfo(),
            price: '',
            departmentList: [], //上级代理商列表
            selectDepartmentVisiable: false,
            intetPorjectList: MAP_LIST.INTENT_PROJECT,
            choicePoliceList: this.$store.state.ChoicePolicyList, //选择政策
            LevelTypes: this.$store.state.LevelTypes, //用户等级
            AgentTypes: [{
                "id": 1,
                "value": "独家"
            }, {
                "id": 2,
                "value": "非独家"
            }, ],
            isZqw: false, //判断智趣坞
            isOnly: false, //判断显示代理类型
            isAgentTypeOne: true, //判断独家（true）非独家
            rules: {
                DepartmentName: [{
                    required: !this.disabled,
                    message: '请选择上级代理商'
                }],
                AgentTypeId: [{
                    required: !this.disabled,
                    message: '请选择代理类型'
                }],
                Bond: [{
                    validator: (rule, value, callback) => {
                        if (!(value >= 0)) {
                            callback(new Error('请填写正确的数字！'));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],
                StartDate: [{
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            this.$notify({
                                title: '警告',
                                message: '请选择代理期限的开始时间！',
                                type: 'warning'
                            });
                            callback(new Error('请选择代理期限的开始时间！'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }],
                EndDate: [{
                    validator: (rule, value, callback) => {
                        let agentInfo = this.agentInfo;
                        if (value === '') {
                            this.$notify({
                                title: '警告',
                                message: '请选择代理期限的结束时间！',
                                type: 'warning'
                            });
                            callback(new Error('请选择代理期限的结束时间！'));
                        } else if (util.compareDate(util.time2str(agentInfo.StartDate), util.time2str(agentInfo.EndDate))) {
                            this.$notify({
                                title: '警告',
                                message: '代理期限结束时间要大于开始时间！',
                                type: 'warning'
                            });
                            callback(new Error('结束时间要大于开始时间！'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }]
            },
            imgViewVisiable: false,
            imgViewSrc: '', //查看大图src
            isRequired: false, //用来判断只有正式级别，合同号，授权期限，公开课是否必填
            isEdit: false,
            isMoneyDisable: false, //设备预付款是否可以编辑
            areaList: [{}], //签约区域
            addAreaClass: 'addArea' //class定义
        };
    },
    created() {
        if (isCorrectVal(this.value)) {
            this.setValue();
            return;
        }
        this.agentInfo = this.refGetAgenInfo();

    },
    computed: {
        sysSid() {
            return this.$store.state.sysSid;
        },
        sysSession() {
            return this.$store.state.sysSession;
        },
        container() {
            return 'container-' + new Date().getTime();
        },
        browse_button() {
            return 'upload-btn-' + new Date().getTime();
        },
        OrderNum_button() {
            return 'OrderNum-btn-' + new Date().getTime();
        },

        adh_container() {
            return 'adh_container-' + new Date().getTime();
        },
        adhbrowse_button() {
            return 'adh_upload-btn-' + new Date().getTime();
        },
        adcoop_container() {
            return 'adcoop_container-' + new Date().getTime();
        },
        adcoop_button() {
            return 'adcoop_upload-btn-' + new Date().getTime();
        },
        OrderNum_container() {
            return 'OrderNum_upload-btn-' + new Date().getTime();
        },
        getIndex() {
            return '签约信息-' + this.myIndex;
        },
        //公开课
        isShowGkk() {
            if (this.agentInfo.ProjectType == 4) {
                // 智趣坞
                return true;
            }
            return false;
        },
        // 签约区域中的区不显示
        setComHide() {
            if (this.agentInfo.ProjectType == 2 || this.agentInfo.ProjectType == 4) {
                // hi幼教和智趣坞
                return true;
            }
            return false;
        },
        hasDelBtnShow() {
            if (this.isReadOnly || this.myIndex == 1) {
                // 第一个不显示删除按钮
                return false;
            }
            if (!this.hasDelFn) {
                return false;
            }
            return true;
        },
        isHideChoicePolice() {
            if (this.agentInfo.ProjectType == 2) {
                // hi幼教
                return false;
            }
            return true;
        },
        setAndReadonlyPolice() {
            return false;
        },
        showPolicyRequire() {
            if (this.agentInfo.AgentLevel == this.DescriptionList[1].key) {
                return true;
            }
            return false;
        },
        cptInReadonlyCanUpdate_AgentLevel() {
            if (this.isReadOnly && this.inReadonlyCanUpdate_AgentLevel) {
                return true;
            }
            return false;
        },
        cptInReadonlyCanUpdate_OpenClass() {
            if (this.isReadOnly && this.inReadonlyCanUpdate_OpenClass) {
                return true;
            }
            return false;
        },
        //只有选择体验级别为true(联帮在线套餐调整需求2017/12/7)
        isLevel() {
            if (this.agentInfo.AgentLevel == 3 && this.isZqw) {
                return true;
            }
            return false;
        },
        // C级商 B级商 A级商：合同号必填；需上传经销合作协议
        browseRequired() {
            if (this.agentInfo.RebateLevel !== 1 && this.agentInfo.PolicyType == 64) {
                return true
            } else {
                return false
            }
        },
        // 用户等级必填
        showRebateLevel() {
            if (this.agentInfo.PolicyType == 64) {
                return true
            } else {
                return false
            }
        },
        // 判断合同号是不是必填
        isCoopNumRequied() {
            if (this.agentInfo.RebateLevel !== 1 && this.agentInfo.PolicyType == 64) {
                return true
            } else {
                false
            }

        }
    },
    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.setValue();
            }
        }
    },
    methods: {
        refGetAgenInfo() {
            return cloneDeep({
                AgentLevel: 0,
                PolicyType: '',
                ProjectType: 1,
                StartDate: null, //date, 代理期限开始时间
                EndDate: null, //date, 代理期限结束时间
                Bond: 0, //num, 保证金数额
                OpenClass: 0,
                HNC_Drawing: [], //代理合同
                "AreaList": [], //签约区域
                ConsigneeId: '',
                ContractNumber: "",
                ConsigneeAddress: '',
                AuthDepositHolder: "",
                AuthDepHolderIDNumber: "", //委托打款人身份证号
                //ListSignMateriel: [],
                AuthDepositHolder_Drawing: [], //委托打款人身份证图片
                FirstGoodsNum: '', //独家首批订货量
                FirstGoodsPrice: '', //独家订货单价
                ContractMoney: '', //合同预付款
                DevicePreMoney: '', //设备预付款
                ProxyType: 1, //代理类型（独家/非独家）
                SaleOrderNum: '', //销售订货单号
                RetailOrderNum: '', // 体验零售订单
                SaleOrderNum: '', //销售订货单号
                RetailOrderNums: [], // 体验零售订单
                RebateLevel: '', // 用户等级 默认小蚂蚁
                CooperateIntent: [] //合作意向书
            });
        },
        // 添加签约区域
        addArea() {
            this.areaList.push({})
        },
        // 删除签约区域
        delAreafn(item) {
            this.areaList.splice((item.index - 1), 1);
        },
        refGetAreaInfo() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            });
        },
        refSetDeliveryAddress(item) {
            this.$nextTick(() => {
                this.agentInfo.ConsigneeId = item.Id;
                this.agentInfo.ConsigneeAddress = item.Address;
            });
        },
        clearData() {
            this.agentInfo = (this.refGetAgenInfo());
            //this.areaInfo = (this.refGetAreaInfo());
        },
        //只有代理商商级别为正式的（合同号，授权时间，公开课）是必填的，其余级别（合同号，授权时间，公开课）不必填,
        changeAgentLevel(val) {
            //val==1为正式
            //只有图书正式 没有代理类型  
            //新增体验级别也没有代理类型（2017/12/7联帮在线套餐调整）
            if (val == 1 || val == 3) {
                this.isRequired = true
                this.isOnly = false

            } else {
                this.isRequired = false
                this.isOnly = true
            }
        },

        // 选择代理类型
        changeAgentType(val) {

            if (val == 2) {
                this.isAgentTypeOne = false
            } else {
                this.isAgentTypeOne = true
            }
        },
        setCptInReadonlyCanUpdate_PolicyTypeName() {
            this.cptInReadonlyCanUpdate_PolicyTypeName = true;
            //暂时保留
            // if (this.isReadOnly && $.trim(this.agentInfo.PolicyTypeName).length == 0) {
            //     this.cptInReadonlyCanUpdate_PolicyTypeName = true;
            //     return;
            // }
            // this.cptInReadonlyCanUpdate_PolicyTypeName = false;
        },
        // 设置值
        setValue() {
            this.$nextTick(() => {

                let agentInfo = cloneDeep(this.value);
                this.agentInfo = $.extend({}, this.refGetAgenInfo(), util.filterAndSetData(this.refGetAgenInfo(), agentInfo));
                // 签约区域赋值
                if (agentInfo.ListDetail) {
                    this.areaList = []

                    let len = agentInfo.ListDetail.length
                    for (let i = 0; i < len; i++) {
                        this.areaList.push({
                            Provinces_Id: agentInfo.ListDetail[i].ProvId,
                            City_Id: agentInfo.ListDetail[i].CityId,
                            Area_Id: agentInfo.ListDetail[i].AreaId
                        })

                    }
                    console.log(this.areaList)
                }

                // this.areaInfo = $.extend({}, this.refGetAreaInfo(), {
                //     Provinces_Id: agentInfo.ProvId,
                //     City_Id: agentInfo.CityId,
                //     Area_Id: agentInfo.AreaId
                // });
                // if (this.areaInfo.Provinces_Id == 0) {
                //     this.areaInfo = {
                //         Provinces_Id: '',
                //         City_Id: '',
                //         Area_Id: ''
                //     };
                // }

                if (this.agentInfo.AgentLevel == 1 || this.agentInfo.AgentLevel == 3) {
                    //val==1为正式
                    //只有图书正式 没有代理类型
                    //新增体验级别也没有代理类型
                    this.isRequired = true
                    this.isOnly = false
                } else {
                    this.isRequired = false
                    this.isOnly = true
                }
                // 正式级别的不可编辑，试课/体验级别可以切换为正式 1== 图书正式 2==Q4正式
                if (this.agentInfo.AgentLevel == 1 || this.agentInfo.AgentLevel == 2) {
                    this.isEdit = true;
                } else {
                    this.isEdit = false;
                }

                //-Q4正式 合同预付款、设备预付款不可编辑，试课this.agentInfo.AgentLevel=0情况下可以编辑
                if (this.agentInfo.AgentLevel == 2) {
                    this.isMoneyDisable = true
                } else {
                    this.isMoneyDisable = false
                }

                this.price = this.agentInfo.FirstGoodsPrice
                this.setCptInReadonlyCanUpdate_PolicyTypeName();
                this.isSetData = true;
            });

        },

        setAgentLeveState(proId) {
            if (proId == 4) {
                // 智趣坞
                this.DescriptionList = [{
                    key: 0,
                    value: "试课",
                    disabled: false
                }, {
                    key: 1,
                    value: "图书正式",
                    disabled: false
                }, {
                    key: 3,
                    value: "体验",
                    disabled: false
                }, {
                    key: 2,
                    value: "2017Q4正式",
                    disabled: false
                }]
            } else {
                // 联帮 hi幼教
                this.DescriptionList = this.$store.state.DescriptionList
            }

        },
        setPolicyState(proId) {
            if (proId !== 2) {
                // 非hi幼教
                this.agentInfo.PolicyType = "";
            }
            if (this.isAdd) {
                this.agentInfo.PolicyType = 4;
            }
            if (!this.isAdd) {
                this.emitSetEveryAgentInfoOfPolicy();
            }

        },
        // 切换签约项目
        changeIntentProject(val) {
            if (!isCorrectVal(this.value)) {
                // 新增
                this.agentInfo.RebateLevel = ''
                this.agentInfo.PolicyType = 0
            } else {
                // 修改项目
                if (this.value.ProjectType !== val) {
                    this.agentInfo.RebateLevel = ''
                    this.agentInfo.PolicyType = 0
                }
            }

            if (!this.isEdit) {
                // z新增区域时候
                if (val == 2 || val == 4) {
                    this.agentInfo.OpenClass = 5;
                } else {
                    this.agentInfo.OpenClass = 0;
                }
            }

            if (val == 4) {
                this.isZqw = true
            } else {
                this.isZqw = false
            }
            this.$nextTick(() => {
                this.setAgentLeveState(val);
                if (this.isSetData && val !== '') {
                    return;
                }
                this.isSetData = false;

                this.setPolicyState(val);
            });
        },
        showSelectDepartment() {
            this.selectDepartmentVisiable = true;
        },
        selectDepartment(value) {
            if (value.D_Name === "后台代理商") return;
            this.agentInfo.DepartmentId = value.Id;
            this.agentInfo.DepartmentName = value.D_Name;
            this.selectDepartmentVisiable = false;
        },
        delAdh_Drawing(i) {
            this.agentInfo.AuthDepositHolder_Drawing.splice(i, 1);
        },
        // 合作意向书删除
        delcoop_Drawing(i) {
            this.agentInfo.CooperateIntent.splice(i, 1);
        },
        delOrderNum_Drawing(i) {
            this.agentInfo.RetailOrderNums.splice(i, 1);
        },
        delC_Drawing(i) {
            this.agentInfo.HNC_Drawing.splice(i, 1);
        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        changePolicy(item) {
            console.log(item)
            if (item == 64) {
                this.agentInfo.OpenClass = 0;
                //this.agentInfo.RebateLevel = 1
            } else if (this.agentInfo.ProjectType == 2 && item !== 64) {
                this.agentInfo.OpenClass = 5;
                this.agentInfo.RebateLevel = ''
                this.agentInfo.CooperateIntent = []
            } else {
                this.agentInfo.OpenClass = 0;
                this.agentInfo.RebateLevel = ''
                this.agentInfo.CooperateIntent = []
            }
            this.agentInfo.PolicyType = item;
            // if (item == 64) {
            //     this.agentInfo.RebateLevel = 1
            // } else {
            //     this.agentInfo.RebateLevel = ''
            // }
            if (!this.isAdd) {
                this.emitSetEveryAgentInfoOfPolicy();
            }
        },
        // 向上派发SetEveryAgentInfoOfPolicy事件
        emitSetEveryAgentInfoOfPolicy() {
            if (this.agentInfo.PolicyType == '' || this.isHideChoicePolice) {

                this.$emit('setEveryAgentInfoOfPolicy', {
                    ProjectType: this.agentInfo.ProjectType,
                    isUpdateEveryPolicy: 0
                });
                return;
            }
            //let policyType = util.getItemByIdInArr(this.agentInfo.PolicyTypeName, this.choicePoliceList, 'value');
            this.$emit('setEveryAgentInfoOfPolicy', {
                isUpdateEveryPolicy: 1,
                ProjectType: this.agentInfo.ProjectType,
                PolicyType: this.agentInfo.PolicyType
            });
        },
        getPolicyValue() {
            let policyType = this.agentInfo.PolicyType

            if (this.isAdd) {
                return {
                    PolicyType: policyType ? policyType.key : "2"
                };
            } else {
                return {
                    PolicyType: policyType ? policyType.key : ""
                };
            }

        },
        getProjectType() {
            // return util.getItemByIdInArr(this.agentInfo.ProjectTypeName, this.intetPorjectList, 'name').id;
        },
        setPolicyByValue(value) {
            //如果policy是隐藏起来的，则不修改数据
            // if (this.isHideChoicePolice) {
            //     return;
            // }
            // this.agentInfo.PolicyTypeName = value;

        },
        getAreaDetails() {
            if (!this.isLevel) {


                // let areaForm = this.$refs.areaForm.validate();
                // if (!!areaForm) {

                //     this.agentInfo.ProvId = areaForm.Provinces_Id;
                //     this.agentInfo.CityId = areaForm.City_Id;
                //     this.agentInfo.AreaId = areaForm.Area_Id;
                //     this.agentInfo._provName = areaForm.provName;
                //     this.agentInfo._cityName = areaForm.cityName;
                //     this.agentInfo._areaName = areaForm.areaName;

                //     return {
                //         ProvId: areaForm.Provinces_Id,
                //         CityId: areaForm.City_Id,
                //         AreaId: areaForm.Area_Id,
                //         _provName: areaForm.provName,
                //         _cityName: areaForm.cityName,
                //         _areaName: areaForm.areaName
                //     };
                // }
            }

            // return Object.assign({}, this.refGetAreaInfo(), {
            //     _provName: "",
            //     _cityName: "",
            //     _areaName: "",
            // });
        },
        areaSelectChange(i) {
            let areaForm = this.$refs['areaForm' + (i + 1)][0].validate();
            this.areaList[i].Provinces_Id = areaForm.Provinces_Id
            this.areaList[i].City_Id = areaForm.City_Id
            this.areaList[i].Area_Id = areaForm.Area_Id
            // for (let i = 0; i < this.areaList.length; i++) {
            //     let areaForm = this.$refs['areaForm' + (i + 1)][0].validate();
            //     this.areaList[i].Provinces_Id = areaForm.Provinces_Id
            //     this.areaList[i].City_Id = areaForm.City_Id
            //     this.areaList[i].Area_Id = areaForm.Area_Id

            // }
            console.log(this.areaList)
            this.agentInfo.ConsigneeAddress = "";
        },
        validate() {
            //选择智趣坞下的体验级别，1)销售订货单号：2) 委托打款人 3) 委托打款人身份证4) 体验零售订单5) 收货信息仅销售订货单号为必填 （2017/12/7联帮在线套餐调整需求）
            // 智趣坞下的体验级别不需要提交授权经销期限

            this.$refs.form.validate(valid => {
                this.valid = valid;
            });


            if (this.isLevel) {
                var areaForm = true
            } else {

                this.agentInfo.AreaList = []
                for (let i = 0; i < this.areaList.length; i++) {
                    var areaForm = this.$refs['areaForm' + (i + 1)][0].validate();

                    this.agentInfo.AreaList.push({
                        "ProvId": areaForm.Provinces_Id,
                        "CityId": areaForm.City_Id,
                        "AreaId": areaForm.Area_Id
                    })

                }
                this.areaInfo.OpenClass = 0
            }
            let rules = [];

            //当下发代理级别为会销、Q4正式，修改签约项目为联帮在线时，提交时候把this.agentInfo.AgentLevel=2置空，提示必填

            if (this.agentInfo.AgentLevel == 2 && this.agentInfo.ProjectType == 1) {
                this.agentInfo.AgentLevel = ''
                rules.push({
                    name: "代理级别",
                    value: this.agentInfo.AgentLevel,
                    required: true
                });
            }
            // 当选择了体验级别之后改了签约项目，则提交时候把this.agentInfo.AgentLevel=2置空，提示必填
            if (this.agentInfo.AgentLevel == 3 && this.agentInfo.ProjectType !== 4) {
                this.agentInfo.AgentLevel = ''
                rules.push({
                    name: "代理级别",
                    value: this.agentInfo.AgentLevel,
                    required: true
                });
            }
            // 用户级别
            if (this.showRebateLevel) {
                rules.push({
                    name: "用户等级",
                    value: this.agentInfo.RebateLevel,
                    required: true
                });
            }
            //新增代理商，合同号不必填，只有正式级别才必填（冰冰） 小蚂蚁不需要填写合同号
            if (!this.isHideContractNumber && this.agentInfo.RebateLevel !== 1 && (this.isRequired || this.isCoopNumRequied)) {
                rules.push({
                    name: "合同号",
                    value: this.agentInfo.ContractNumber,
                    required: true
                });
            }
            if (!this.isLevel) {
                rules.push({
                    name: "授权经销期限",
                    value: this.agentInfo.StartDate,
                    required: true
                });
            } else if (this.isLevel) {
                this.agentInfo.StartDate = ''
                this.agentInfo.EndDate = ''
            }

            if (!this.isHideChoicePolice && this.showPolicyRequire) {
                rules.push({
                    name: "政策",
                    value: this.agentInfo.PolicyType,
                    required: true
                });
            }

            rules.push({
                name: "签约项目",
                value: this.agentInfo.ProjectType,
                required: true,
                msg: '请选择签约项目'
            }, {
                name: "物料收货地址",
                value: this.agentInfo.ConsigneeAddress,
                required: false // 根据业务需求 暂时先屏蔽掉
            });
            //新增代理商，公开课不必填，只有正式级别才必填
            if (!this.isAdd && this.isRequired) {
                rules.push({
                    name: "公开课",
                    value: this.agentInfo.OpenClass,
                    isNumber: true
                });
            }
            //新增代理类型（独家/非独家），选择独家时，新增必填字段：独家首批订货量，合同预付款   非独家必填字段：独家首批订货量，设备预付款
            if (this.isZqw && this.isOnly) {
                if (this.agentInfo.ProxyType == 0) {
                    this.agentInfo.ProxyType = ''
                    rules.push({
                        name: "代理类型",
                        value: this.agentInfo.ProxyType,
                        required: true
                    })
                }
                if (this.isAgentTypeOne) {
                    this.agentInfo.DevicePreMoney = ''; //设备预付款数据清空
                    // 必填逻辑：合同预付款填写了，订货量和订货单价选填，但是订货量或者订货单价其中一个填写，另外一个就是必填，而合同预付款为选填
                    if (this.agentInfo.ContractMoney > 0) {
                        if (this.agentInfo.FirstGoodsNum > 0 && this.agentInfo.FirstGoodsPrice == '') {
                            this.$notify({
                                title: '警告',
                                message: '独家订货单价不能为空！',
                                type: 'warning'
                            });
                            return;
                        } else if (this.agentInfo.FirstGoodsPrice > 0 && this.agentInfo.FirstGoodsNum == '') {
                            this.$notify({
                                title: '警告',
                                message: '独家订货量不能为空！',
                                type: 'warning'
                            });
                            return;
                        }
                    } else {
                        if (this.agentInfo.FirstGoodsNum > 0 && this.agentInfo.FirstGoodsPrice > 0) {} else {
                            if (this.agentInfo.FirstGoodsNum > 0 && this.agentInfo.FirstGoodsPrice == '') {
                                this.$notify({
                                    title: '警告',
                                    message: '独家订货单价不能为空！',
                                    type: 'warning'
                                });
                                return;
                            } else if (this.agentInfo.FirstGoodsPrice > 0 && this.agentInfo.FirstGoodsNum == '') {
                                this.$notify({
                                    title: '警告',
                                    message: '独家订货量不能为空！',
                                    type: 'warning'
                                });
                                return;
                            } else {
                                this.$notify({
                                    title: '警告',
                                    message: '独家订货量和独家订货单价不能为空！',
                                    type: 'warning'
                                });
                                return;
                            }
                        }

                    }

                } else {
                    this.agentInfo.ContractMoney = ''; //合同预付款数据清空
                    this.agentInfo.FirstGoodsNum = '' //独家订货量数据清空
                    this.agentInfo.FirstGoodsPrice = '' //独家订货单价清空
                    rules.push({
                        name: "设备预付款",
                        value: this.agentInfo.DevicePreMoney,
                        required: true
                    })
                }
            } else {
                this.agentInfo.ProxyType = 0
                this.agentInfo.DevicePreMoney = ''; //设备预付款数据清空
                this.agentInfo.ContractMoney = ''; //合同预付款数据清空
                this.agentInfo.FirstGoodsNum = '' //独家订货量数据清空
                this.agentInfo.FirstGoodsPrice = '' //独家订货单价清空
            }

            if (this.isLevel) {
                // 只有智趣坞体验级别 体验零售订单/销售订货单号是必填
                rules.push({
                    name: "销售订货单号",
                    value: this.agentInfo.SaleOrderNum,
                    required: true
                }, {
                    name: "体验零售订单",
                    value: this.agentInfo.RetailOrderNums,
                    required: true
                })
            } else if (this.isZqw) {
                this.agentInfo.OpenClass = 0
            }
            if (this.agentInfo.RebateLevel == 1) {
                rules.push({
                    name: "合作意向书",
                    value: this.agentInfo.CooperateIntent,
                    required: true,
                    msg: "请上传合作意向书"
                });
            }
            if (this.browseRequired) {
                rules.push({
                    name: "经销合同协议",
                    value: this.agentInfo.HNC_Drawing,
                    required: true,
                    msg: "请上传经销合同协议"
                });
            }
            let flag = util.checkForm({
                ele: this,
                rules: rules
            });
            console.log(this.agentInfo)
            if (this.isHideContractNumber || this.agentInfo.RebateLevel == 1) {
                // 不需要合同号
                this.agentInfo.ContractNumber = ''

            }
            if (this.valid && !!areaForm && flag) {
                // 用户级别
                if (this.agentInfo.PolicyType !== 64) {
                    // 不是Q2地推政策，用户级别置空
                    this.agentInfo.RebateLevel = ''
                }
                if (this.isHideChoicePolice) {
                    // 不是hi幼教项目的政策置空
                    this.agentInfo.PolicyType = ''
                }

                // this.agentInfo.ProjectType = util.getItemByIdInArr(this.agentInfo.ProjectTypeName, this.intetPorjectList, 'name').id;
                // this.agentInfo.PolicyType = util.getItemByIdInArr(this.agentInfo.PolicyTypeName, this.choicePoliceList, 'value').key;
                console.log(this.agentInfo)
                return this.agentInfo;
            }
            return false;
        },
        resetFields() {
            this.$refs.form.resetFields();
            //this.$refs.areaForm.resetFields();
            for (let i = 0; i < this.areaList.length; i++) {
                this.$refs['areaForm' + (i + 1)][0].resetFields();
            }

            this.areaList = [{}];
            this.clearData();
        },
        deletefn(index) {
            this.$emit('delAgentfn', {
                index: index
            });
        },
        showChoicedAddressDiaolog() {
            this.$emit('showChoicedAddressDiaolog', {
                "level": this.agentInfo.AgentLevel
            });
        }
    },
    mounted() {
        this.$nextTick(() => {

            util.initUploader(this, this.container, this.browse_button, (file) => {
                this.agentInfo.HNC_Drawing.push(file);
            });

            util.initUploader(this, this.adh_container, this.adhbrowse_button, (file) => {
                this.agentInfo.AuthDepositHolder_Drawing.push(file);
            });
            // 合作意向书
            util.initUploader(this, this.adcoop_container, this.adcoop_button, (file) => {
                this.agentInfo.CooperateIntent.push(file);
            });
            util.initUploader(this, this.OrderNum_container, this.OrderNum_button, (file) => {
                this.agentInfo.RetailOrderNums.push(file);
            });
            if (this.isSetData) {
                return;
            }

            if (this.isAdd) {
                this.agentInfo.ProjectType = 2;
                this.agentInfo.AgentLevel = this.DescriptionList[2].key
            } else {
                this.agentInfo.ProjectType = 1;
                this.agentInfo.AgentLevel = this.DescriptionList[0].key
                if (this.agentInfo.AgentLevel == 1 || this.agentInfo.AgentLevel == 3) {
                    //val==1为正式
                    //只有图书正式 没有代理类型  
                    //新增体验级别也没有代理类型（2017/12/7联帮在线套餐调整）
                    this.isRequired = true
                    this.isOnly = false
                } else {
                    this.isRequired = false
                    this.isOnly = true
                }
            }
        });
    }
};


// WEBPACK FOOTER //
// ./src/common/components/agent-info/vm.js